"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AddOn_1 = __importDefault(require("./AddOn"));
/*
  The function getAddons generates sibling <AddOn /> components for each key in the addOnsConfig it receives.
  We call this function to generate children for a <FormContainer />
*/
const getAddOns = (addOnsConfig = {}, onTrack) => {
    const addOnsConfigKeys = Object.keys(addOnsConfig);
    const addOns = [];
    for (const k of addOnsConfigKeys) {
        addOns.push(react_1.default.createElement(AddOn_1.default, { onTrack: onTrack, key: k, addOnType: k, content: addOnsConfig[k] }));
    }
    return addOns;
};
exports.default = getAddOns;
//# sourceMappingURL=getAddOns.js.map